<template>
  <youtubePlayer />
</template>

<script>
import youtubePlayer from '@/components/youtubePlayer.vue'
export default {
  name: 'App',
  components: {
    youtubePlayer
  }
}
</script>

<style>

</style>
